import { defineNuxtPlugin } from '#app'
import type { VueI18n } from 'vue-i18n'

export enum EErrorCode {
  FEATURE_IS_DISABLED = 160131,
  CLIENT_ID_EMPTY = 100,
  SEARCH_TERM_EMPTY = 101,
  PAGE_OPTIONS_EMPTY = 102,
  INPUT_EMPTY = 103,
  INPUTS_EMPTY = 104,
  REQUEST_TOKEN_EMPTY = 105,
  USER_TOKEN_DATA_EMPTY = 106,
  INVALID_CONFIGURATION_SETTINGS = 107,
  CONFIGURATION_SETTINGS_NOT_FOUND = 108,
  MORE_THAN_ONE_ITEM_FOUND = 109,
  ITEM_NOT_FOUND = 110,
  NO_DATA_TO_EXPORT = 111,
  INVALID_ENTITY_CONFIGURATION = 112,
  OPERATION_RESULT_EMPTY = 113,
  GENERIC_ERROR = 114,
  MAXIMUM_FIELD_LENGTH_EXCEEDED = 115,
  HTTP_BAD_REQUEST = 400,
  HTTP_UNAUTHORIZED = 401,
  HTTP_PAYMENT_REQUIRED = 402,
  HTTP_FORBIDDEN = 403,
  HTTP_NOT_FOUND = 404,
  HTTP_METHOD_NOT_ALLOWED = 405,
  HTTP_NOT_ACCEPTABLE = 406,
  HTTP_PROXY_AUTHENTICATION_REQUIRED = 407,
  HTTP_REQUEST_TIMEOUT = 408,
  HTTP_CONFLICT = 409,
  HTTP_GONE = 410,
  HTTP_LENGTH_REQUIRED = 411,
  HTTP_PRECONDITION_FAILED = 412,
  HTTP_PAYLOAD_TOO_LARGE = 413,
  HTTP_URI_TOO_LONG = 414,
  HTTP_UNSUPPORTED_MEDIA_TYPE = 415,
  HTTP_REQUESTED_RANGE_NOT_SATISFIABLE = 416,
  HTTP_EXPECTATION_FAILED = 417,
  HTTP_MISDIRECTED_REQUEST = 421,
  HTTP_PRECONDITION_REQUIRED = 428,
  HTTP_TOO_MANY_REQUESTS = 429,
  HTTP_REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
  HTTP_INTERNAL_SERVER_ERROR = 500,
  HTTP_NOT_IMPLEMENTED = 501,
  HTTP_BAD_GATEWAY = 502,
  HTTP_SERVICE_UNAVAILABLE = 503,
  HTTP_GATEWAY_TIMEOUT = 504,
  AUDIENCE_SCHEMA_NOT_FOUND = 1000,
  SCHEMA_COLUMN_KEY_EMPTY = 1001,
  SCHEMA_COLUMN_NAME_EMPTY = 1002,
  SCHEMA_COLUMN_NOT_FOUND = 1003,
  SCHEMA_COLUMN_IS_KEY = 1004,
  AUDIENCE_SCHEMA_EMPTY = 1005,
  SCHEMA_COLUMN_NAME_ALREADY_EXISTS = 1006,
  DEFAULT_FIELD_DATA_TYPE_NOT_FOUND = 2000,
  AUDIENCE_FILE_EMPTY = 3000,
  AUDIENCE_FILE_EXTENSION_INVALID = 3001,
  AUDIENCE_FILE_SIZE_EXCEEDED = 3002,
  AUDIENCE_FILE_INVALID_FORMULA = 3003,
  DEFAULT_KNOWN_COLUMN_NOT_FOUND = 4000,
  IMPORT_AUDIENCE_NOT_FOUND = 5000,
  ERROR_CREATING_IMPORT_AUDIENCE = 5001,
  FILE_GUID_EMPTY = 5002,
  SUMMARY_ITEMS_EMPTY = 5003,
  COLUMNS_MUST_BE_MAPPED_OR_IGNORED = 5004,
  INCOMPLETE_KEY_COLUMN_MAPPING = 5005,
  INVALID_KEY_COLUMN_MAPPING = 5006,
  INVALID_COLUMN_TYPE_MAPPING = 5007,
  INVALID_IMPORT_AUDIENCE = 5008,
  DISTINCTS_FILE_NOT_FOUND = 5009,
  DUPLICATES_FILE_NOT_FOUND = 5010,
  CHUNK_SUCCESS_FILE_NOT_FOUND = 5011,
  CHUNK_ERROR_FILE_NOT_FOUND = 5012,
  EXPORT_DATE_EXPIRED = 5013,
  RECIPIENTS_LIST_EMPTY = 5014,
  KEY_FIELDS_LIST_EMPTY = 5015,
  DUPLICATED_COLUMN_NAME = 5016,
  NO_COLUMN_WITH_CONTACT_DATA_PROVIDED = 5017,
  ONLY_1_MSISDN_CONTACT_DATA_COLUMN_ALLOWED = 5018,
  ONLY_1_EMAIL_CONTACT_DATA_COLUMN_ALLOWED = 5019,
  IMPORTID_EMPTY = 5020,
  ERROR_UPDATING_IMPORT_AUDIENCE = 5021,
  IMPORT_SCHEMA_EMPTY = 5022,
  INVALID_KEY_CONFIGURATION = 5023,
  CHUNK_FILE_NOT_FOUND = 5024,
  PLAN_RECIPIENT_LIMIT_EXCEEDED = 5025,
  MAXIMUM_DUPLICATES_EXCEEDED = 5026,
  COMPANY_NAME_EMPTY = 6000,
  BUSINESS_AREA_EMPTY = 6001,
  ORGANIZATION_ID_EMPTY = 6002,
  ORGANIZATION_NOT_FOUND = 6004,
  ORGANIZATION_USER_NOT_FOUND = 6005,
  ERROR_UPDATING_ORGANIZATION = 6006,
  ORGANIZATION_WITHOUT_USERS = 6007,
  ERROR_CREATING_ORGANIZATION_USER = 6008,
  ERROR_UPDATING_ORGANIZATION_USER = 6009,
  ERROR_DELETING_ORGANIZATION_USER = 6010,
  ORGANIZATION_USER_ALREADY_EXISTS = 6011,
  ERROR_CREATING_ORGANIZATION = 6012,
  ERROR_DELETING_ORGANIZATION = 6013,
  ORGANIZATION_ID_INCORRECT = 6014,
  ORGANIZATION_IS_NULL = 6015,
  BILLING_INFO_IS_NULL = 6016,
  CONTACT_EMAIL_EMPTY = 6017,
  CONTACT_PHONE_COUNTRY_INDICATOR_EMPTY = 6018,
  CONTACT_PHONE_NUMBER_EMPTY = 6019,
  ORGANIZATION_TYPE_INVALID = 6020,
  BUSINESS_AREA_INAVLID = 6021,
  COUNTRY_EMPTY = 6022,
  CITY_EMPTY = 6023,
  POSTAL_CODE_EMPTY = 6024,
  ADDRESS_EMPTY = 6025,
  TAX_IDENTIFICATION_NUMBER_EMPTY = 6026,
  ONLY_NUMBER = 6027,
  ORGANIZATION_HAS_ACTIVE_DESCENDENTS = 6028,
  UNABLE_TO_GET_ORGANIZATION_SALES_MANAGER = 6029,
  UNABLE_TO_GET_DEFAULT_SALES_MANAGER = 6030,
  BUSINESS_PROFILE_EMPTY = 6031,
  INVALID_ORGANIZATION_TYPE = 6032,
  ORGANIZATION_USER_ALREADY_DISABLED = 6033,
  ORGANIZATION_USER_ALREADY_ACTIVE = 6034,
  ORGANIZATION_HAS_NOT_DELETED_DESCENDENTS = 6035,
  ORGANIZATION_ALREADY_DISABLED = 6036,
  ORGANIZATION_ALREADY_ENABLED = 6037,
  ORGANIZATION_ALREADY_DELETED = 6038,
  ORGANIZATION_CONTACT_DETAILS_ID_EMPTY = 6039,
  ORGANIZATION_CONTACT_DETAILS_NOT_FOUND = 6040,
  CONTACT_DETAILS_TYPE_EMPTY = 6041,
  INVALID_CONTACT_DETAILS_TYPE = 6042,
  INVALID_INVOICE_CONFIGURATION = 6043,
  BILLING_INFO_NOT_FOUND = 6044,
  ORGANIZATION_BILLING_INFO_NOT_FOUND = 6045,
  BILLING_INFO_NOT_EMPTY = 6046,
  INVALID_ORGANIZATION_CONFIGURATION = 6047,
  ORGANIZATION_BALANCE_CONFIG_TYPE_INVALID_UPDATE = 6048,
  UNABLE_TO_GET_BALANCE_OWNER = 6049,
  ORGANIZATION_HAS_NOT_ACTIVE_ANCESTORS = 6050,
  INVALID_ORGANIZATION_STATUS = 6051,
  ORGANIZATION_STATUS_INVALID_UPDATE = 6052,
  USER_ALREADY_HAVE_ASSOCIATION_WITH_A_CLIENT_ORGANIZATION = 6053,
  UNABLE_TO_GET_ROOT_ORGANIZATION = 6054,
  USER_CAN_NOT_CREATE_ORGANIZATION = 6055,
  SENDIT_ORGANIZATION_CAN_NOT_BE_DESCENDANT_OF_CLIENT_ORGANIZATION = 6056,
  UNABLE_TO_USE_PARENT_BILLING_INFO = 6057,
  COMPANY_NAME_EXCEEDS_MAXIMUM_LENGTH = 6058,
  MAX_PLAN_SUBACCOUNT_LIMIT_REACHED = 6059,
  MAX_PLAN_USER_COUNT_REACHED = 6060,
  EMAIL_DESTINATION_EMPTY = 7000,
  EMAIL_MESSAGE_EMPTY = 7001,
  EMAIL_SUBJECT_EMPTY = 7002,
  EMAIL_FROM_EMPTY = 7003,
  EMAIL_TO_EMPTY = 7004,
  EMAIL_CONTENT_TYPE_EMPTY = 7005,
  TOPIC_EMPTY = 7006,
  TOKEN_EMPTY = 8000,
  EXTERNAL_LOGIN_PASSWORD_MUST_BE_EMPTY = 8001,
  GOOGLE_DATA_NOT_FOUND = 8002,
  LINKEDIN_DATA_NOT_FOUND = 8003,
  USER_NOT_YET_REGISTERED = 8004,
  SMS_MESSAGE_EMPTY = 9000,
  SMS_MSISDN_EMPTY = 9001,
  SMS_TEXT_EXCEEDS_MAXIMUM_LENGTH = 9002,
  MSISDN_DESTINATION_EMPTY = 9003,
  USER_ID_EMPTY = 10001,
  ROLE_EMPTY = 10002,
  CURRENT_PASSWORD_EMPTY = 10003,
  EMAIL_EMPTY = 10004,
  EMAIL_NOT_VALID = 10005,
  NEW_PASSWORD_EMPTY = 10006,
  CONFIRM_PASSWORD_EMPTY = 10007,
  NEW_PASSWORD_CONFIRM_PASSWORD_MISMATCH = 10008,
  PASSWORD_EMPTY = 10009,
  VALIDATION_CODE_EMPTY = 10010,
  PHONE_COUNTRY_INDICATOR_EMPTY = 10011,
  PHONE_NUMBER_EMPTY = 10012,
  NAME_EMPTY = 10013,
  SIGNUP_TYPE_EMPTY = 10014,
  USER_NOT_FOUND = 10015,
  PASSWORD_NOT_UNIQUE = 10016,
  EMAIL_ALREADY_CONFIRMED = 10017,
  EMAIL_VALIDATION_CODE_INCORRECT = 10018,
  EMAIL_VALIDATION_CODE_EXPIRED = 10019,
  PHONE_ALREADY_CONFIRMED = 10020,
  PHONE_VALIDATION_CODE_INCORRECT = 10021,
  PHONE_VALIDATION_CODE_EXPIRED = 10022,
  USER_ALREADY_EXISTS = 10023,
  PHONE_NUMBER_DUPLICATED = 10024,
  EMAIL_PASSWORD_INVALID = 10025,
  TIMEZONE_INVALID = 10026,
  USER_NOT_UPDATED = 10027,
  INVALID_PASSWORD_LENGTH = 10028,
  INSECURE_PASSWORD = 10029,
  ERROR_UPDATING_USER = 10030,
  LAST_USER_FROM_ORGANIZATION = 10031,
  USER_ALREADY_DISABLED = 10032,
  USER_ACCOUNT_NOT_CONFIRMED = 10033,
  USER_IS_DISABLED = 10034,
  ERROR_CREATING_USER = 10035,
  ERROR_REGISTERING_USER = 10036,
  ERROR_CREATING_USER_PASSWORD_HISTORY = 10037,
  USER_ID_MISMATCH = 10038,
  USER_ALREADY_ACTIVE = 10039,
  USER_CONTEXT_NOT_FOUND = 10040,
  USER_DOES_NOT_BELONG_TO_ORGANIZATION = 10041,
  USER_IS_INACTIVE = 10042,
  USER_DOES_NOT_HAVE_PRIVILEGE_OVER_ORGANIZATION = 10043,
  USER_NAME_EXCEEDS_MAXIMUM_LENGTH = 10044,
  INVALID_PARENT_ORGANIZATION = 10045,
  MSISDN_INVALID = 10046,
  PASSWORD_EXPIRED = 10047,
  ID_EMPTY = 11000,
  ID_NOT_VALID = 11001,
  RESET_TOKEN_EMPTY = 11002,
  ID_NOT_EMPTY = 11003,
  ERROR_CREATING_IMPORT_AUDIENCE_FILE = 12000,
  IMPORT_AUDIENCE_FILE_NOT_FOUND = 12001,
  MISSING_UPLOADED_FILE = 12002,
  NO_RECIPIENTS_FOUND = 13000,
  AUDIENCE_EVOLUTION_DATA_NOT_FOUND = 13001,
  AUDIENCE_SCORE_METRICS_NOT_FOUND_OR_NOT_YET_GENERATED = 13002,
  AUDIENCE_CUSTOM_TYPE_NOT_FOUND = 14000,
  AUDIENCE_CUSTOM_TYPES_ALREADY_EXISTS = 14001,
  AUDIENCE_CUSTOM_TYPES_EQUALS_RESERVED_TYPE = 14002,
  AUDIENCE_CUSTOM_FIELD_KEY_IS_EMPTY = 14003,
  AUDIENCE_CUSTOM_FIELD_NOT_FOUND = 14004,
  AUDIENCE_CUSTOM_FIELD_IS_NOT_GROUP_CUSTOM = 14005,
  RECIPIENT_ID_EMPTY = 15000,
  RECIPIENT_DATA_EMPTY = 15001,
  INVALID_RECIPIENT_STATUS = 15002,
  INVALID_SUBSCRIPTION_KEY = 15003,
  AUDIENCE_RECIPIENT_ID_EMPTY = 15004,
  RECIPIENT_PROCESS_RESULT_CODE_ID_EMPTY = 15005,
  RECIPIENT_PROCESS_RESULT_TYPE_ID_EMPTY = 15006,
  ERROR_CREATING_RECIPIENT = 15007,
  ERROR_UPDATING_RECIPIENT = 15008,
  ERROR_DELETING_RECIPIENT = 15009,
  RECIPIENT_NOT_FOUND = 15010,
  ERROR_CREATING_EMAIL_RECIPIENT = 15011,
  ERROR_UPDATING_EMAIL_RECIPIENT = 15012,
  ERROR_DELETING_EMAIL_RECIPIENT = 15013,
  EMAIL_RECIPIENT_NOT_FOUND = 15014,
  EMAIL_RECIPIENT_ID_EMPTY = 15015,
  ERROR_CREATING_SMS_RECIPIENT = 15016,
  ERROR_UPDATING_SMS_RECIPIENT = 15017,
  ERROR_DELETING_SMS_RECIPIENT = 15018,
  SMS_RECIPIENT_NOT_FOUND = 15019,
  SMS_RECIPIENT_ID_EMPTY = 15020,
  EXPIRATION_DATETIME_EMPTY = 15021,
  ENCONDING_EMPTY = 15022,
  TOTAL_CHARACTERS_EMPTY = 15023,
  TOTAL_SEGMENTS_EMPTY = 15024,
  AUDIENCE_RECIPIENT_ID_MISMATCH = 15025,
  BEGIN_TIME_MISMATCH = 15026,
  END_TIME_MISMATCH = 15027,
  EXPIRATION_DATETIME_MISMATCH = 15028,
  IS_WORKING_DAYS_MISMATCH = 15029,
  SCHEDULE_DATETIME_MISMATCH = 15030,
  TIMEZONE_MISMATCH = 15031,
  PARAM_INVALID = 15032,
  PARAM_EMPTY = 15033,
  SCHEMA_MISMATCH = 15034,
  MAX_PLAN_RECIPIENT_COUNT_REACHED = 15035,
  AUDIENCE_KEY_UPDATE_NOT_ALLOWED = 15036,
  RECIPIENT_ALREADY_EXISTS = 15037,
  EXPORT_FORMAT_INVALID = 16000,
  INVALID_SUBSCRIPTION = 17000,
  ERROR_SENDING_ZEEBE_MESSAGE = 18000,
  ZEEBE_MESSAGE_NAME_EMPTY = 18001,
  ZEEBE_CORRELATION_KEY_EMPTY = 18002,
  SEND_ZEEBE_MESSAGE_EMPTY = 18003,
  NOTE_EMPTY = 19000,
  NOTE_CONTENT_EMPTY = 19001,
  NEW_NOTE_NOT_INSERTED = 19002,
  NOTE_KEY_EMPTY = 19003,
  NOTE_NOT_UPDATED = 19004,
  NOTE_NOT_FOUND = 19005,
  TAG_EMPTY = 20000,
  INVALID_TAG_NAME = 20001,
  CSV_DELIMITER_CHAR_NOT_DEFINED = 21000,
  CSV_DELIMITER_EMPTY = 21001,
  SEGMENT_EMPTY = 22000,
  SEGMENT_NAME_EMPTY = 22001,
  SEGMENT_GROUP_EMPTY = 22002,
  SEGMENT_QUERY_EMPTY = 22003,
  SEGMENT_QUERY_INVALID = 22004,
  SEGMENT_NOT_FOUND = 22005,
  SEGMENT_ID_EMPTY = 22006,
  ERROR_CREATING_SEGMENT = 22007,
  DEFAULT_FIELD_CATEGORIES_NOT_FOUND = 23000,
  IMPORT_AUDIENCE_INVALIDS_NOT_FOUND = 24000,
  ERROR_CREATING_IMPORT_AUDIENCE_INVALIDS = 24001,
  DEFAULT_OPERATOR_NOT_FOUND = 25000,
  EVENT_OUTBOX_NOT_FOUND = 26000,
  AGGREGATE_ID_EMPTY = 26001,
  AGGREGATE_TYPE_EMPTY = 26002,
  CLASSIFICATION_EMPTY = 26003,
  DOMAIN_EMPTY = 26004,
  EVENT_TYPE_EMPTY = 26005,
  PAYLOAD_EMPTY = 26006,
  VERSION_EMPTY = 26007,
  EMAIL_OUTBOX_ID_EMPTY = 26008,
  EMAIL_OUTBOX_NOT_FOUND = 26009,
  ERROR_CREATING_EMAIL_OUTBOX = 26010,
  SMS_OUTBOX_ID_EMPTY = 26011,
  SMS_OUTBOX_NOT_FOUND = 26012,
  ERROR_CREATING_SMS_OUTBOX = 26013,
  ROLE_NOT_FOUND = 27000,
  ROLE_ALREADY_EXISTS = 27001,
  ROLE_ID_EMPTY = 27002,
  ORGANIZATION_TYPE_EMPTY = 27003,
  DESCRIPTION_EMPTY = 27004,
  WEIGHT_EMPTY = 27005,
  NOT_CUSTOM_ROLE_CANT_BE_UPDATED = 27006,
  NOT_CUSTOM_ROLE_CANT_BE_DELETED = 27007,
  ERROR_CREATING_ROLE = 27008,
  ERROR_UPDATING_ROLE = 27009,
  ERROR_DELETING_ROLE = 27010,
  ASSIGNABLE_PERMISSION_NOT_FOUND = 28000,
  ASSIGNABLE_PERMISSION_ALREADY_EXISTS = 28001,
  ASSIGNABLE_PERMISSION_ID_EMPTY = 28002,
  PERMISSION_EMPTY = 28003,
  ERROR_CREATING_ASSIGNABLE_PERMISSION = 28004,
  ERROR_DELETING_ASSIGNABLE_PERMISSION = 28005,
  ASSIGNABLE_PERMISSIONS_FROM_NOT_CUSTOM_ROLE_CANT_BE_DELETED = 28006,
  CAN_NOT_ADD_ASSIGNABLE_PERMISSIONS_TO_NOT_CUSTOM_ROLE = 28007,
  DEFAULT_PERMISSION_NOT_FOUND = 29000,
  DEFAULT_PERMISSION_ALREADY_EXISTS = 29001,
  DEFAULT_PERMISSION_ID_EMPTY = 29002,
  ERROR_CREATING_DEFAULT_PERMISSION = 29004,
  ERROR_DELETING_DEFAULT_PERMISSION = 29005,
  DEFAULT_PERMISSIONS_FROM_NOT_CUSTOM_ROLE_CANT_BE_DELETED = 29006,
  CAN_NOT_ADD_DEFAULT_PERMISSIONS_TO_NOT_CUSTOM_ROLE = 29007,
  ORGANIZATION_USER_ID_EMPTY = 29003,
  ORGANIZATION_TYPE_MISMATCH = 29008,
  ORGANIZATION_USER_ALREADY_EXISTS_IN_HIERARCHY = 29009,
  ORGANIZATION_USER_PERMISSION_NOT_FOUND = 30000,
  ORGANIZATION_USER_PERMISSION_ALREADY_EXISTS = 30001,
  ORGANIZATION_USER_PERMISSION_ID_EMPTY = 30002,
  ERROR_CREATING_ORGANIZATION_USER_PERMISSION = 30004,
  ERROR_DELETING_ORGANIZATION_USER_PERMISSION = 30005,
  USER_UNAUTHORIZED = 31000,
  VALIDATE_EMAIL_RULE_FIELD_IS_MANDATORY = 100000,
  VALIDATE_EMAIL_RULE_INVALID_FORMAT = 100001,
  VALIDATE_MSISDN_RULE_FIELD_IS_MANDATORY = 101000,
  VALIDATE_MSISDN_RULE_INVALID_FORMAT = 101001,
  VALIDATE_INTEGER_RULE_FIELD_IS_MANDATORY = 101002,
  VALIDATE_INTEGER_RULE_INVALID_FORMAT = 101003,
  INTEGER_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 101004,
  VALIDATE_DATETIME_RULE_FIELD_IS_MANDATORY = 101005,
  VALIDATE_DATETIME_RULE_INVALID_FORMAT = 101006,
  DATETIME_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 101007,
  VALIDATE_IMPORT_AUDIENCE_RECIPIENT_FIELDS_RULE_INVALID_RECIPIENT = 102000,
  EMAIL_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 103000,
  MSISDN_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 103001,
  IMPORT_AUDIENCE_RECIPIENT_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 103002,
  SMS_BUSINESS_RULES_PROCESSOR_EMPTY_ENTITY = 103003,
  SENDER_IS_NULL_OR_EMPTY = 10600,
  REQUEST_ORGANIZATION_USER_ID_IS_INVALID = 106001,
  ORIGINAL_FILE_NAME_IS_NULL_OR_EMPTY = 106002,
  FILE_DATA_IS_INVALID = 106003,
  INVALID_STATUS_APPROVE_REJECT = 106004,
  REASON_TEXT_IS_NULL_OR_EMPTY = 106005,
  SENDER_ALREADY_APPROVED_REJECTED = 106006,
  FILE_NOT_FOUND = 106007,
  SENDER_INACTIVE = 106008,
  ORGANIZATION_SENDER_ID_IS_EMPTY = 106009,
  ORGANIZATION_USER_ID_IS_EMPTY = 106010,
  ENABLING_ORGANIZATION_USER_ID_IS_EMPTY = 106011,
  ORGANIZATION_SENDER_NOT_FOUND = 106012,
  ONLY_APPROVED_SENDERS_CAN_BE_REMOVED = 106013,
  ANSWER_ORGANIZATION_USER_ID_IS_EMPTY = 106014,
  SENDER_ALREADY_EXISTS = 106015,
  ONLY_AUTHENTICATED_DOMAIN_SENDERS_CAN_BE_REMOVED = 106016,
  SENDER_ALREADY_APPROVED_OR_REFUSED = 106017,
  VALUE_IS_NULL_OR_EMPTY = 106018,
  NAME_HOST_IS_NULL_OR_EMPTY = 106019,
  INVALID_STATUS_SUBMIT_AUTHENTICATION_REFUSED = 106020,
  SENDER_NOT_PENDING_CONFIGURATION = 106021,
  SENDER_NOT_FOUND = 106022,
  DOMAIN_SENDER_ALREADY_PENDING_CONFIGURATION = 106023,
  INVALID_STATUS_AUTHENTICATE_UNAUTHENTICATE = 106025,
  EMAIL_DOMAIN_IS_NULL_OR_EMPTY = 106026,
  EMAIL_KEY_IS_NULL_OR_EMPTY = 106027,
  EMAIL_DOMAIN_NOT_FOUND = 106028,
  SENDER_NAME_EMPTY = 106029,
  SENDER_NAME_INVALID = 106030,
  ERROR_PROCESSING_SENDER_NAME = 106031,
  SENDER_FILE_EXTENSION_INVALID = 106032,
  ONLY_DOMAIN_SENDERS_WITH_FINISHED_CAMPAIGN_CAN_BE_REMOVED = 106033,
  ERROR_DELETING_SENDER = 106034,
  SENDER_ALREADY_EXISTS_IN_ANOTHER_ORGANIZATION = 106035,
  TEMPLATE_NOT_FOUND = 107000,
  TEMPLATE_CONTENT_EMPTY = 107001,
  TEMPLATE_NAME_EMPTY = 107002,
  TEMPLATE_ID_EMPTY = 107003,
  TEMPLATE_HTML_FILE_EMPTY = 107004,
  TEMPLATE_HTML_FILE_EXTENSION_EMPTY = 107005,
  TEMPLATE_HTML_FILE_NAME_EMPTY = 107006,
  TEMPLATE_OPTIONAL_CONTENT_FILE_EXTENSION_EMPTY = 107007,
  TEMPLATE_OPTIONAL_CONTENT_FILE_NAME_EMPTY = 107008,
  TEMPLATE_HTML_FILE_EXTENSION_INVALID = 107009,
  TEMPLATE_OPTIONAL_CONTENT_FILE_EXTENSION_INVALID = 1007010,
  TEMPLATE_NAME_ALREADY_EXISTS = 1007011,
  TEMPLATE_HTML_URL_IS_EMPTY = 1007012,
  TEMPLATE_HTML_URL_IS_INVALID = 1007013,
  ERROR_CREATING_TEMPLATE = 1007014,
  ERROR_UPDATING_TEMPLATE = 1007015,
  TEMPLATE_TYPE_EMPTY = 1007016,
  ERROR_CALCULATING_TEMPLATE_TYPE = 1007017,
  TEMPLATE_ID_NOT_EMPTY = 1007018,
  INVALID_PARENT_TEMPLATE = 1007019,
  TEMPLATE_THUMBNAIL_FILE_NAME_EMPTY = 1007020,
  TEMPLATE_CONTENT_NOT_EMPTY = 1007021,
  TEMPLATE_THUMBNAIL_URL_IS_EMPTY = 1007022,
  TEMPLATE_HTML_URL_IS_NOT_EMPTY = 1007023,
  TEMPLATE_THUMBNAIL_URL_IS_NOT_EMPTY = 1007024,
  TEMPLATE_HTML_FILE_NAME_NOT_EMPTY = 1007025,
  TEMPLATE_THUMBNAIL_FILE_NAME_NOT_EMPTY = 1007026,
  HTML_BUILDER_DATA_EMPTY = 1007027,
  HTML_BUILDER_DATA_NOT_EMPTY = 1007028,
  EMAIL_TEMPLATES_TO_PROCESS_COUNT_EMPTY = 1007029,
  INVALID_HTML_BUILDER_TEMPLATE = 1007030,
  ERROR_CREATING_EMAIL_TEMPLATE_FILES = 1007031,
  TEMPLATE_UNSUBSCRIBE_TAG_NOT_FOUND = 1007032,
  INVALID_TEMPLATE_STATUS = 1007033,
  SMS_TEMPLATES_TO_PROCESS_COUNT_EMPTY = 1007034,
  TEMPLATE_FILE_NOT_GENERATED = 1007035,
  UNABLE_TO_ACCESS_URL = 1007036,
  TEMPLATE_HTML_BUILDER_FILE_EXTENSION_INVALID = 1007037,
  EMAIL_TEMPLATE_IMPORT_NOT_ENABLED = 1007038,
  MAX_PLAN_EMAIL_TEMPLATE_REACHED = 1007039,
  TEMPLATE_CONTENT_EXCEEDED_AVAILABLE_CHARACTERS = 1007040,
  TEMPLATE_DEFAULT_TEMPLATE_ALREADY_EXISTS = 1007041,
  TEMPLATE_DEFAULT_TEMPLATE_NAME_IS_EMPTY = 1007042,
  TEMPLATE_DEFAULT_TEMPLATE_DESCRIPTION_IS_EMPTY = 1007043,
  DEFAULT_TEMPLATE_NOT_FOUND = 1007044,
  ERROR_EXPORT_HTML_UNLAYER = 1007045,
  INVITEE_EMAIL_EMPTY = 108000,
  INVITE_NOT_FOUND = 108001,
  INVITE_ID_EMPTY = 108002,
  INVITE_STATUS_INVALID = 108003,
  INVITE_DATE_EXPIRED = 108004,
  CHANNEL_NOT_FOUND = 109000,
  INVALID_CHANNEL = 109001,
  AUTO_SAVE_DATETIME_EMPTY = 110000,
  SAVE_DATETIME_EMPTY = 110001,
  ERROR_CREATING_CAMPAIGN = 110002,
  ERROR_UPDATING_CAMPAIGN = 110003,
  ERROR_DELETING_CAMPAIGN = 110004,
  CAMPAIGN_NOT_FOUND = 110005,
  CAMPAIGN_ID_EMPTY = 110006,
  CAMPAIGN_NAME_INVALID_UPDATE = 110007,
  CAMPAIGN_WORKFLOW_INVALID_UPDATE = 110008,
  AUTO_SAVE_DATETIME_INVALID_UPDATE = 110009,
  SCHEDULE_DATETIME_INVALID_UPDATE = 110010,
  CAMPAIGN_STATUS_INVALID_UPDATE = 110011,
  SAVE_DATETIME_INVALID_UPDATE = 110012,
  INVALID_CAMPAIGN_STATUS = 110013,
  CAMPAIGN_ID_MISMATCH = 110014,
  CAMPAIGN_TEST_EMAIL_EXCEEDED = 110015,
  CAMPAIGN_ID_NOT_EMPTY = 110016,
  CAMPAIGN_TEST_SMS_EXCEEDED = 110017,
  CAMPAIGN_TEST_MONTHLY_EXCEEDED = 110018,
  CAMPAIGN_TEST_EXCEEDED = 110019,
  CAMPAIGN_TEST_ORGANIZATION_EXCEEDED = 110020,
  DELETED_CAMPAINS_TO_PROCESS_COUNT_EMPTY = 110021,
  EMAIL_RECIPIENTS_TO_DELETE_COUNT_EMPTY = 110022,
  SMS_RECIPIENTS_TO_DELETE_COUNT_EMPTY = 110023,
  INVALID_CAMPAIGN_WORKFLOW = 110024,
  DELETED_SCHEDULINGS_TO_PROCESS_COUNT_EMPTY = 110025,
  SMS_RESULT_NOT_FOUND = 110026,
  SCHEDULED_DATE_REACHED_FOR_PLAN = 110027,
  CAMPAIGN_WORKFLOW_SCHEDULE_DATETIME_INVALID = 110029,
  MOBILE_OPERATOR_NOT_FOUND = 130000,
  MOBILE_OPERATOR_COUNTRY_NOT_FOUND = 130001,
  NEW_MOBILE_OPERATOR_EMPTY = 130002,
  MOBILE_OPERATOR_COUNTRY_ID_EMPTY = 130003,
  MOBILE_OPERATOR_FULL_NAME_EMPTY = 130004,
  MOBILE_OPERATOR_SHORT_NAME_EMPTY = 130005,
  MOBILE_OPERATOR_SHORT_NAME_LENGTH_TOO_LONG = 130006,
  MOBILE_OPERATOR_MCC_EMPTY = 130007,
  MOBILE_OPERATOR_MNC_EMPTY = 130008,
  MOBILE_OPERATOR_VALIDATION_REGEX_EMPTY = 130009,
  MOBILE_OPERATOR_ID_EMPTY = 130010,
  NEW_MOBILE_OPERATOR_COUNTRY_EMPTY = 130011,
  MOBILE_OPERATOR_COUNTRY_FULL_NAME_EMPTY = 130012,
  MOBILE_OPERATOR_COUNTRY_SHORT_NAME_EMPTY = 130013,
  MOBILE_OPERATOR_COUNTRY_SHORT_NAME_LENGTH_TOO_LONG = 130014,
  NEW_COUNTRY_EMPTY = 130015,
  MOBILE_OPERATOR_COUNTRY_ALREADY_EXISTS = 130016,
  MOBILE_OPERATOR_COUNTRY_END_DATE_EMPTY = 130017,
  MOBILE_OPERATOR_END_DATE_EMPTY = 130018,
  MOBILE_OPERATOR_EXTERNAL_DATA_INTEGRATION_EMPTY = 130019,
  ERROR_REQUESTING_MOBILE_OPERATOR = 130020,
  MOBILE_OPERATOR_LIST_EMPTY = 130021,
  ERROR_CREATING_SCHEDULING = 140000,
  ERROR_UPDATING_SCHEDULING = 140001,
  ERROR_DELETING_SCHEDULING = 140002,
  SCHEDULING_NOT_FOUND = 140003,
  SCHEDULING_ID_EMPTY = 140004,
  ERROR_CREATING_EMAIL_SCHEDULING = 140005,
  ERROR_UPDATING_EMAIL_SCHEDULING = 140006,
  ERROR_DELETING_EMAIL_SCHEDULING = 140007,
  EMAIL_SCHEDULING_NOT_FOUND = 140008,
  EMAIL_SCHEDULING_ID_EMPTY = 140009,
  ERROR_CREATING_SMS_SCHEDULING = 140010,
  ERROR_UPDATING_SMS_SCHEDULING = 140011,
  ERROR_DELETING_SMS_SCHEDULING = 140012,
  SMS_SCHEDULING_NOT_FOUND = 140013,
  SMS_SCHEDULING_ID_EMPTY = 140014,
  BEGIN_TIME_EMPTY = 140015,
  CHANNEL_EMPTY = 140016,
  END_TIME_EMPTY = 140017,
  IS_WORKING_DAYS_EMPTY = 140018,
  SCHEDULE_DATETIME_EMPTY = 140019,
  TIMEZONE_EMPTY = 140020,
  SCHEDULING_TYPE_EMPTY = 140021,
  CHANNEL_MISMATCH = 140022,
  ORGANIZATION_ID_MISMATCH = 140023,
  ORGANIZATION_USER_ID_MISMATCH = 140024,
  SCHEDULED_SMS_NOT_FOUND = 140025,
  SCHEDULED_SMS_OUTBOX_NOT_FOUND = 140026,
  CANCELED_SCHEDULING_NOT_FOUND = 140027,
  LIMIT_EMPTY = 140028,
  SCHEDULED_EMAIL_NOT_FOUND = 140029,
  SCHEDULED_EMAIL_OUTBOX_NOT_FOUND = 140030,
  SCHEDULING_EMPTY = 140031,
  EMAIL_SCHEDULING_EMPTY = 140032,
  SMS_SCHEDULING_EMPTY = 140033,
  CONFIGS_EMPTY = 140034,
  SCHEMA_EMPTY = 140035,
  TABLE_EMPTY = 140036,
  COLUMN_EMPTY = 140037,
  MINUTES_EMPTY = 140038,
  SCHEDULING_CANCELLED = 140039,
  API_KEY_EMPTY = 150000,
  API_KEY_INVALID = 150001,
  MTMID_EMPTY = 150002,
  STATUS_CODE_EMPTY = 150003,
  STATUS_CODE_INVALID = 150004,
  PLAN_ID_EMPTY = 160000,
  PLAN_NOT_FOUND = 160001,
  PLAN_TIER_ID_EMPTY = 160002,
  PLAN_TIER_NOT_FOUND = 160003,
  INVALID_PLAN_TIER_ID = 160004,
  PERIOD_PLAN_TIER_PRICE_ID_EMPTY = 160005,
  PERIOD_PLAN_TIER_PRICE_NOT_FOUND = 160006,
  ORGANIZATION_PLAN_ID_EMPTY = 160007,
  ORGANIZATION_PLAN_NOT_FOUND = 160008,
  INVALID_ORGANIZATION_PLAN_ID = 160009,
  ORGANIZATION_PLAN_PERIOD_PLAN_TIER_PRICE_ID_EMPTY = 160010,
  ORGANIZATION_PLAN_PERIOD_PLAN_TIER_PRICE_NOT_FOUND = 160011,
  ADD_ON_ID_EMPTY = 160012,
  ADD_ON_NOT_FOUND = 160013,
  ADD_ON_EMAIL_ID_EMPTY = 160014,
  ADD_ON_EMAIL_NOT_FOUND = 160015,
  INVALID_ADD_ON_EMAIL_ID = 160016,
  ADD_ON_ORGANIZATION_EMAIL_ID_EMPTY = 160017,
  ADD_ON_ORGANIZATION_EMAIL_NOT_FOUND = 160018,
  ADD_ON_SMS_ID_EMPTY = 160019,
  ADD_ON_SMS_NOT_FOUND = 160020,
  INVALID_ADD_ON_SMS_ID = 160021,
  ADD_ON_ORGANIZATION_SMS_ID_EMPTY = 160022,
  ADD_ON_ORGANIZATION_SMS_NOT_FOUND = 160023,
  ASSIGNABLE_ADD_ON_ID_EMPTY = 160024,
  ASSIGNABLE_ADD_ON_NOT_FOUND = 160025,
  DEFAULT_ADD_ON_ID_EMPTY = 160026,
  DEFAULT_ADD_ON_NOT_FOUND = 160027,
  BALANCE_TRANSACTION_ID_EMPTY = 160028,
  BALANCE_TRANSACTION_NOT_FOUND = 160029,
  EMAIL_BALANCE_TRANSACTION_ID_EMPTY = 160030,
  EMAIL_BALANCE_TRANSACTION_NOT_FOUND = 160031,
  SMS_BALANCE_TRANSACTION_ID_EMPTY = 160032,
  SMS_BALANCE_TRANSACTION_NOT_FOUND = 160033,
  ORGANIZATION_BALANCE_CONFIG_ID_EMPTY = 160034,
  ORGANIZATION_BALANCE_CONFIG_NOT_FOUND = 160035,
  ORGANIZATION_BALANCE_EMAIL_ID_EMPTY = 160036,
  ORGANIZATION_BALANCE_EMAIL_NOT_FOUND = 160037,
  ORGANIZATION_BALANCE_SMS_ID_EMPTY = 160038,
  ORGANIZATION_BALANCE_SMS_NOT_FOUND = 160039,
  FEATURE_ID_EMPTY = 160040,
  FEATURE_NOT_FOUND = 160041,
  ORGANIZATION_PLAN_FEATURE_ID_EMPTY = 160042,
  ORGANIZATION_PLAN_FEATURE_NOT_FOUND = 160043,
  ORGANIZATION_HAS_NO_OWN_BALANCE = 160044,
  INVALID_TRANSACTION_AMOUNT = 160045,
  INSUFFICIENT_BALANCE = 160046,
  INVALID_BALANCE_TRANSACTION_TYPE = 160047,
  REQUESTED_ORGANIZATION_ID_EMPTY = 160048,
  TARGET_ORGANIZATION_ID_EMPTY = 160049,
  TRANSACTION_AMOUNT_EMPTY = 160050,
  TARGET_ORGANIZATION_ID_NOT_EMPTY = 160051,
  INVALID_TARGET_ORGANIZATION_ID = 160052,
  BALANCE_THRESHOLD_ID_EMPTY = 160053,
  BALANCE_THRESHOLD_NOT_FOUND = 160054,
  ADD_ON_ORGANIZATION_EMAIL_ALREADY_EXISTS = 160055,
  ADD_ON_ORGANIZATION_SMS_ALREADY_EXISTS = 160056,
  ORGANIZATION_BALANCE_CONFIG_TYPE_EMPTY = 160057,
  INVALID_ORGANIZATION_BALANCE_CONFIG_TYPE = 160058,
  INVALID_PLAN_TYPE = 160059,
  INVALID_ADD_ON_TYPE = 160060,
  BALANCE_OWNER_ORGANIZATION_ID_EMPTY = 160061,
  BALANCE_OWNER_ORGANIZATION_ID_NOT_EMPTY = 160062,
  ORGANIZATION_BALANCE_CONFIG_TYPE_NOT_EMPTY = 160063,
  ORGANIZATION_HAS_MORE_THAN_ONE_ACTIVE_ORGANIZATION_PLAN = 160064,
  ORGANIZATION_ALREADY_HAVE_AN_ACTIVE_PLAN = 160065,
  PLAN_ID_NOT_EMPTY = 160066,
  PERIOD_PLAN_TIER_PRICE_ID_NOT_EMPTY = 160067,
  PERIOD_PLAN_TIER_PRICE_ID_IS_REQUIRED = 160068,
  PLAN_TYPE_EMPTY = 160069,
  PLAN_NAME_EMPTY = 160070,
  UNABLE_TO_GET_PLAN_INFO = 160071,
  INVALID_DEFAULT_ADD_ON = 160072,
  ORGANIZATION_ALREADY_HAVE_ACTIVE_EMAIL_ADDONS = 160073,
  ORGANIZATION_ALREADY_HAVE_ACTIVE_SMS_ADDONS = 160074,
  ORGANIZATION_ALREADY_HAVE_ACTIVE_ADDONS = 160075,
  ORGANIZATION_DOES_NOT_HAVE_AN_ACTIVE_PLAN = 160076,
  INVALID_PLAN_REPLACEMENT = 160077,
  INVALID_PERIOD_PLAN_TIER_PRICE_REPLACEMENT = 160078,
  ERROR_CREATING_ORGANIZATION_PLAN = 160079,
  ERROR_CREATING_ORGANIZATION_PLAN_PERIOD_PLAN_TIER_PRICE = 160080,
  ERROR_CREATING_ORGANIZATION_PLAN_FEATURES = 160081,
  ERROR_CREATING_ADD_ON = 160082,
  ERROR_CREATING_ADD_ON_EMAIL = 160083,
  ERROR_CREATING_ADD_ON_ORGANIZATION_EMAIL = 160084,
  ERROR_CREATING_ADD_ON_SMS = 160085,
  ERROR_CREATING_ADD_ON_ORGANIZATION_SMS = 160086,
  UNABLE_TO_GET_ORGANIZATION_PLAN_INFO = 160087,
  UNABLE_TO_GET_PARENT_ORGANIZATION_PLAN_INFO = 160088,
  ORGANIZATION_TRIAL_PLAN_EXPIRED = 160089,
  ORGANIZATION_PAYMENT_METHOD_NOT_FOUND = 160090,
  STRIPE_CUSTOMER_NOT_FOUND = 160091,
  COUNTRY_ID_EMPTY = 160092,
  DETAIL_COUNTRY_EMPTY = 160093,
  REASONS_IS_NULL_OR_EMPTY = 160094,
  FIELD_EXCEEDS_MAXIMUM_LENGTH = 160095,
  REASONS_NOT_FOUND = 160096,
  ORGANIZATION_DOES_HAVE_AN_SUSPENDED_PLAN = 160097,
  BALANCE_RENEWAL_PERIOD_EMPTY = 160098,
  BALANCE_VALUE_EMPTY = 160099,
  ADDON_RECURRENCE_TYPE_EMPTY = 160100,
  ASSIGNABLE_ADD_ONS_EMAIL_EMPTY = 160101,
  ASSIGNABLE_ADD_ONS_SMS_EMPTY = 160102,
  DEFAULT_ADD_ONS_EMAIL_EMPTY = 160103,
  DEFAULT_ADD_ONS_SMS_EMPTY = 160104,
  PLAN_TIERS_EMPTY = 160105,
  DEFAULT_ADD_ONS_EMPTY = 160106,
  FEATURES_EMPTY = 160107,
  MIN_AUDIENCE_RECIPIENTS_EMPTY = 160108,
  MAX_AUDIENCE_RECIPIENTS_EMPTY = 160109,
  MAX_EMAILS_PER_MONTH_EMPTY = 160110,
  PERIOD_PLAN_TIERS_PRICE_EMPTY = 160111,
  PAYMENT_PERIOD_EMPTY = 160112,
  PRICE_EMPTY = 160113,
  PLAN_ALREADY_EXISTS = 160114,
  PROMO_CONFIG_CODE_ALREADY_EXISTS = 160115,
  PROMO_CONFIG_STANDARD_ALREADY_EXISTS = 160116,
  PROMO_CONFIG_TYPE_EMPTY = 160117,
  PROMO_CODE_EMPTY = 160118,
  PROMO_CONFIG_CODE_NOT_FOUND = 160119,
  PLAN_PROMO_CONFIG_NOT_FOUND = 160120,
  PARENT_PLAN_NOT_FOUND = 160121,
  PROMO_CONFIG_ID_EMPTY = 160122,
  PAYMENT_IN_PROGRESS = 160123,
  AUDIENCE_RECIPIENTS_IS_GREATER_THAT_PLAN_TIER_SELECTED = 160124,
  RECURRENT_ADDONS_NOT_EMPTY = 160125,
  ADDONS_NOT_REPORTED_FOR_PAY_AS_YOU_GO = 160126,
  ONLY_ADDON_ONE_SHOT_ARE_ALLOWED_FOR_PAY_AS_YOU_GO = 160127,
  MAX_DAILY_SCHEDULING_LIMIT_REACHED = 160128,
  ORGANIZATION_CAN_NOT_CREATE_BILLING_ACCOUNT = 170000,
  ORGANIZATION_CONFIG_NOT_FOUND = 170001,
  ERROR_CREATING_APIKEY = 180000,
  ERROR_APIKEY_ALREADY_EXISTS = 180001,
  SMART_INSIGHT_CONFIGURATION_NOT_FOUND = 190000,
  SMART_INSIGHT_BUSINESS_AREA_NOT_FOUND = 190001,
  SMART_INSIGHT_CATEGORY_NOT_FOUND = 190002,
  SMART_INSIGHT_WEB_AREA_NOT_FOUND = 190003,
  SMART_INSIGHT_ORGANIZATION_ID_NULL_OR_EMPTY = 190004,
  SMART_INSIGHT_WEB_AREA_NULL = 190005,
  STRIPE_CUSTOMER_ID_EMPTY = 190006,
  PAYMENT_OR_SETUP_METHOD_IS_REQUIRED = 190007,
  PAYMENT_METHOD_IS_EMPTY = 190008,
  PAYMENT_METHOD_NOT_FOUND = 190009,
  PAYMENT_NOT_FOUND = 190010,
  COUTRY_CODE_EMPTY = 190011,
  PERIOD_PLAN_EMPTY = 190012,
  PAYMENT_EMPTY = 190013,
  SETUP_INTENT_EMPTY = 190014,
  SETUP_INTENT_CLIENT_SECRET_EMPTY = 190015,
  PAYMENT_INTENT_EMPTY = 190016,
  PAYMENT_INTENT_NOT_FOUND = 190017,
  ORDER_EMPTY = 190018,
  ORDER_NOT_FOUND = 190019,
  ORDER_ITEM_EMPTY = 190020,
  STRIPE_PAYMENT_EMPTY = 190021,
  STRIPE_PAYMENT_INTENT_NOT_FOUND = 190022,
  PAYMENT_PRICE_EMPTY = 190023,
  ORDER_ITEM_PLAN_EMPTY = 190024,
  ORDER_ITEM_ADDON_EMAIL_EMPTY = 190025,
  ORDER_ITEM_ADDON_SMS_EMPTY = 190026,
  ORDER_ITEM_PLAN_NOT_FOUND = 190027,
  ORDER_ITEM_ADDON_EMAIL_NOT_FOUND = 190028,
  ORDER_ITEM_ADDON_SMS_NOT_FOUND = 190029,
  ERROR_CREATING_WORKFLOW = 200000,
  ERROR_UPDATING_WORKFLOW = 200001,
  ERROR_DELETING_WORKFLOW = 200002,
  WORKFLOW_JSON_EMPTY = 200010,
  WORKFLOW_TRIGGER_JSON_EMPTY = 200011,
  WORKFLOW_TRIGGER_VALUES_EMPTY = 200012,
  WORKFLOW_TRIGGER_DATA_EMPTY = 200013,
  WORKFLOW_TRIGGER_SEGMENT_ID_EMPTY = 200014,
  WORKFLOW_TRIGGER_TYPE_EMPTY = 200015,
  WORKFLOW_TRIGGER_TIMEZONE_EMPTY = 200016,
  WORKFLOW_INVALID_STATUS_UPDATE = 200017,
  WORKFLOW_NOT_FOUND = 200999,
  WORKFLOW_ID_EMPTY = 201000,
  WORKFLOW_STATUS_INVALID = 201001,
  WORKFLOW_STEP_NOT_FOUND = 201002,
  WORKFLOW_DESTINATION_STATUS_NOT_FOUND = 201003,
  WORKFLOW_DESTINATION_STATUS_NOT_ENABLED = 201004,
  WORKFLOW_STEP_TYPE_INVALID = 201005,
  WORKFLOW_STEP_STATUS_INVALID = 201006,
  WEBHOOK_DESTINATION_URL_EMPTY = 2100000,
  WEBHOOK_DESTINATION_NOT_FOUND = 2100001,
  WEBHOOK_DESTINATION_ALREADY_EXISTS = 2100002,
  MFA_MAX_RESENDS_REACHED = 2101000,
  MFA_SMS_ERROR_VALIDATE_CODE = 2101001,
  MFA_SMS_ERROR_SEND_CODE = 2101002,
  MFA_EMAIL_ERROR_VALIDATE_CODE = 2101100,
  MFA_EMAIL_ERROR_SEND_CODE = 2101101,
  MFA_TOKEN_UNKNOWN = 2101200,
  MFA_REQUIRES_TWO_FACTOR_AUTH = 2101300,
  ORGANIZATION_CUSTOMIZATION_NOT_FOUND = 2401000,
  ORGANIZATION_CUSTOMIZATION_LOGO_EMPTY = 2401001,
  ORGANIZATION_CUSTOMIZATION_LOGIN_IMAGE_EMPTY = 2401002,
  ORGANIZATION_CUSTOMIZATION_DOMAIN_ALREADY_EXISTS = 2401003,
  ORGANIZATION_CUSTOMIZATION_LOGIN_IMAGE_EXTENSION_EMPTY = 2401004,
  ORGANIZATION_CUSTOMIZATION_LOGO_IMAGE_EXTENSION_EMPTY = 2401005,
  ORGANIZATION_CUSTOMIZATION_UPDATE_INPUT_EMPTY = 2401006,
  ORGANIZATION_CUSTOMIZATION_BRAND_NAME_EMPTY = 2401007,
  ORGANIZATION_CUSTOMIZATION_BRAND_NAME_TOO_LONG = 2401008,
  ORGANIZATION_CUSTOMIZATION_CONTACT_EMAIL_ADDRESS_EMPTY = 2401009,
  MAILJET_ORGANIZATION_CONFIG_NOT_FOUND = 2501000,
  ATTACHMENT_NOT_FOUND = 2725000,
  ERROR_PARSING_ATTACHMENT = 2725001,
  ATTACHMENT_IS_EMPTY = 2725002,
  ATTACHMENT_IS_EXPIRED = 2725003,
  INBOUND_SMS_CONFIG_UNAUTHORIZED = 2800001,
  ORGANIZATION_INBOUND_SMS_CONFIG_NOT_FOUND = 2800002,
  ORGANIZATION_ACCESS_NUMBER_NOT_FOUND = 2800003,
  TWM_DISABLED = 2800004,
  TWM_CONFIG_EXPIRED = 2800005,
  TWM_CONFIG_UNAVAILABLE = 2800006,
  TWM_INPUT_INVALID = 2800007,
  TWM_ACCESS_NUMBER_NOT_FOUND = 2800008,
  ORGANIZATION_ACCESS_NUMBER_DATETIME_OUT_OF_RANGE = 2800009,
  INBOUND_SMS_ACTION_NOT_CREATED = 2800010,
  INBOUND_SMS_ID_EMPTY = 2800011,
  INVALID_ACTION_CONFIGURATION = 2800012,
  TWM_INBOUND_SMS_NOT_FOUND = 2800013,
  TWM_KEYWORD_NOT_FOUND = 2800014,
  TWM_AUTOMATIC_RESPONSE_NOT_FOUND = 2800015,
  MO_RESPONSE_CAMPAIGN_NOT_FOUND = 2800016,
  TWM_FALLBACK_NOT_WILDCARD = 2800017,
  TWM_KEYWORD_ENDPOINT_IS_EMPTY = 2800018,
  TWM_KEYWORD_ENDPOINT_IS_INVALID = 2800019,
  TWM_KEYWORD_RESPONSE_MSG_IS_EMPTY = 2800020,
  TWM_FALLBACK_KEYWORD_ALREADY_CONFIGURED = 2800021,
  TWM_KEYWORD_CONFLICT_DETECTED = 2800022,
  CAMPAIGN_WORKFLOW_MUST_HAVE_RECIPIENTS = 110030,
  CAMPAIGN_WORKFLOW_SCHEDULE_FIELDS_REQUIRED = 110031,
  CAMPAIGN_WORKFLOW_SEGMENTS_REQUIRED = 110032,
  CAMPAIGN_WORKFLOW_EMAIL_PREFIX_REQUIRED = 110033,
  CAMPAIGN_WORKFLOW_EMAIL_FROM_REQUIRED = 110034,
  CAMPAIGN_WORKFLOW_EMAIL_PREFIX_INVALID = 110035,
  CAMPAIGN_WORKFLOW_EMAIL_REPLY_TO_INVALID = 110036,
  PHONE_NUMBER_NOT_AVAILABLE = 10200,
  AI_ACCESS_DENIED = 3109000,
  AI_CONFIGURATION_UNAVAILABLE = 3109001,
  AI_DAILY_USAGE_LIMIT_EXCEEDED = 3102008,
  AI_MONTHLY_USAGE_LIMIT_EXCEEDED = 3102009,
  AI_EXECUTION_FAILED = 3109002,
  ORGANIZATION_NOT_APPROVED = 6061,
}

// * TODO: Medida provisória. O backend ainda não padronizou o retorno de erros (ora devolve o
// * código numérico, ora o código em texto, ora apenas a mensagem), por isso o front avalia
// * todas as possibilidades. Simplificar para usar só o error code quando o backend padronizar.
// * Converte um candidato (código numérico, código em texto ou mensagem) na chave de tradução
function toErrorKeys(candidate: unknown): string[] {
  if (candidate === undefined || candidate === null || candidate === '') {
    return []
  }

  const value = String(candidate).trim()

  // * Código numérico (number ou string numérica): procura o nome no enum
  if (/^\d+$/.test(value)) {
    const key = Object.keys(EErrorCode).find(
      (enumKey) =>
        EErrorCode[enumKey as keyof typeof EErrorCode] === Number(value),
    )
    return key ? [key] : []
  }

  // * Código ou mensagem em texto: tenta o valor completo e, depois, apenas o prefixo
  // * (ex.: "ORGANIZATION_NOT_APPROVED: Organization does not have ...")
  const prefix = value.match(/^[A-Za-z0-9_]+/)?.[0]
  return prefix && prefix !== value ? [value, prefix] : [value]
}

function handleErrorCode(i18n: VueI18n, candidates: unknown[]) {
  // * Usa o primeiro candidato que tenha tradução
  for (const candidate of candidates) {
    for (const key of toErrorKeys(candidate)) {
      if (i18n.te(`general.errors.${key}`)) {
        return i18n.t(`general.errors.${key}`)
      }
    }
  }

  return i18n.t('general.errors.DEFAULT')
}

export interface IOperationError {
  errorCode: number | string
  errorMessage: string
  exception: string
  errorParameters: string[]
}

export interface IErrorResponse {
  response: {
    data?: {
      errorParameters?: string[]
      errorCode?: number | string
      message?: string
      operationError?: IOperationError
      error?: {
        code?: number | string
        message?: string
      }
      messages?: Array<{
        error: {
          code?: number | string
          message?: string
          description?: string
        }
      }>
    }
    _data?: {
      data?: any
      errorCode?: number | string
      errorParameters?: string[]
      operationError?: IOperationError
      message?: string
      messages?: Array<{
        error: {
          code?: number | string
          message?: string
          description?: string
        }
      }>
      error?: {
        code?: number | string
        message?: string
        description?: string
      }
      success: true
      Data?: any
      ErrorCode?: number | string
      ErrorParameters?: string[]
      Message?: string
      Success: true
    }
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const i18nInstance = nuxtApp.$i18n as VueI18n
  return {
    provide: {
      errorCodeHandler: (error: IErrorResponse): string => {
        // * * Backend pode retornar o error code de várias formas (numérico, em texto ou apenas
        // * * na mensagem), por isso são avaliados todos os candidatos, códigos primeiro
        // * * TODO: Medida provisória até o backend padronizar o retorno de erros
        const response = error?.response
        const data = response?.data
        const _data = response?._data

        const candidates = [
          // * Códigos
          data?.errorCode,
          _data?.ErrorCode,
          _data?.errorCode,
          data?.operationError?.errorCode,
          _data?.operationError?.errorCode,
          data?.error?.code,
          _data?.error?.code,
          data?.messages?.[0]?.error?.code,
          _data?.messages?.[0]?.error?.code,
          // * Mensagens
          data?.message,
          _data?.Message,
          _data?.message,
          data?.operationError?.errorMessage,
          _data?.operationError?.errorMessage,
          data?.error?.message,
          _data?.error?.message,
          _data?.error?.description,
          data?.messages?.[0]?.error?.message,
          data?.messages?.[0]?.error?.description,
          _data?.messages?.[0]?.error?.message,
          _data?.messages?.[0]?.error?.description,
        ]

        return handleErrorCode(i18nInstance, candidates)
      },
    },
  }
})
